
import apiClient from './apiClient';
import axios from 'axios';

//api for fetching contract orders in home page
export const fetchContractOrders = async (pharmacyid,
  taskdetail = "PROCESS",
  column = "",
  value = "",
  userId = "",
  cignaPBMFlag = "") => {
  try {
    const res = await apiClient.post('/order/loadorders', {
      PharmID: pharmacyid, 
      Taskdetail: taskdetail,
      Column: column,
      Value: value,
      UserID: userId,
      CignaPBMFlag: cignaPBMFlag
    });

    console.log("Fetching Contract Orders with payload:", res);

    console.log("Contract Orders API Response:", res.data);

    return {
      data: res.data?.ContractOrders,
      ProcessAndNeeds: res.data?.ProcessAndNeeds, 
    };  
  } catch (error) {
    console.error('Error fetching contract orders:', error);
    return [];
  }
};


//api for loading orders in prescription grid

export const loadOrder = async (
  pharmacyid,
  taskdetail = "PROCESS",
  column = "",
  value = "",
  userId ,
  cignaPBMFlag = ""
) => {
  try {
    const response = await apiClient.post('/order/loadorders', {
      PharmID: pharmacyid,
      Taskdetail: taskdetail,
      Column: column,
      Value: value,
      UserID: userId,
      CignaPBMFlag: cignaPBMFlag
    });
    console.log("Sending payload:", {
  PharmID: pharmacyid,
  Taskdetail: taskdetail,
  Column: column,
  Value: value,
  UserID: userId,
  CignaPBMFlag: cignaPBMFlag
});

    console.log("Raw API response:", response);

    if (response.status === 200 && Array.isArray(response.data?.ProcessAndNeeds)) {
        return {
          success: true,
          data: response.data.ProcessAndNeeds,
          filterData: response.data.FilteredTask
        };
    } else {
      return {
        success: false,
        message: response.data?.Message || "No records found."
      };
    }
  } catch (error) {
    console.error('Error during loadOrder:', error);
    return {
      success: false,
      message: 'An error occurred while loading data. Please try again later.',
    };
  }
};

//api for display lock order 


export const getLockedItems = async (pharmacyId) => {
  try {
    const response = await apiClient.get(`/order/GetLockedItems?PharmID=${pharmacyId}`);
    console.log("Locked Items API Response:", response.data);

    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error("Error fetching locked items:", error);
    return { success: false, data: null };
  }
};



//api for loading rx details in open orders page

export const loadRxDetails = async (taskid, contract, pharmacyid , userid ) => {
    try {
      const payload = {
        TaskId: taskid,
        Contract: contract,
        PharmacyId: pharmacyid,
        UserId: userid
      };
  
      console.log("Sending to LoadRxDetails:", payload);
  
      const response = await apiClient.post('/order/LoadRxDetails', payload);
  
      if (response.status === 200 && response.data?.TaskDetail) {
        console.log("Sending to LoadRxDetails:", {
            TaskID: taskid,
            Contract: contract,
            PharmID: pharmacyid,
            UserID: userid
          });
        return {
          success: true,
          data: response.data
        };
        
      } else {
        return {
          success: false,
          message: response.data?.Message || "No records found."
        };
      }
    } catch (error) {
      console.error('Error during loadRxDetails:', error);
      return {
        success: false,
        message: 'An error occurred while loading data. Please try again later.',
      };
    }
  };
  
  //api for locking rx details while selecting a particular task in prescription grid

  export const lockRXDetails = async (contract, userid, taskid, pharmacyid, process = "LOCK") => {
    try {
      const payload = {
        Contract: contract,
        User: userid,
        TaskId: taskid,
        PharmacyId: pharmacyid, 
        Process: process
      };
      
  
      console.log("Locking RxDetails:", payload);
  
      const response = await apiClient.post('/order/LockOrders', payload);

      console.log("Response from LockOrders:", response.data);
  
      if (response.status === 200 && response.data?.Message === "LOCK is successful.") {
        console.log("Lock successful:", {
          TaskID: taskid,
          Contract: contract,
          PharmacyId: pharmacyid,
          User: userid
        });
  
        return {
          success: true,
          message: response.data.Message,
          userName: response.data.UserName
        };
      } else {
        return {
          success: false,
          message: response.data?.Message || "Unable to lock the task."
        };
      }
  
    } catch (error) {
      console.error('Error during lockRXDetails:', error);
      return {
        success: false,
        message: 'An error occurred while locking the task.'
      };
    }
  };

  export const unlockRXDetails = async (contract, userid, taskid, pharmacyid, process = "UNLOCK") => {
    try {
      const payload = {
        Contract: contract,
        User: userid,
        TaskId: taskid,
        PharmacyId: pharmacyid, 
        Process: process
      };
      
  
      console.log("Unlocking RxDetails:", payload);
  
      const response = await apiClient.post('/order/LockOrders', payload);

      console.log("Response from UnlockOrders:", response.data);
  
      if (response.status === 200 && response.data?.Message === "UNLOCK is successful.") {
        console.log("Unlock successful:", {
          TaskID: taskid,
          Contract: contract,
          PharmacyId: pharmacyid,
          User: userid
        });
  
        return {
          success: true,
          message: response.data.Message,
          userName: response.data.UserName
        };
      } else {
        return {
          success: false,
          message: response.data?.Message || "Unable to unlock the task."
        };
      }
  
    } catch (error) {
      console.error('Error during unlockRXDetails:', error);
      return {
        success: false,
        message: 'An error occurred while unlocking the task.'
      };
    }
  };



export const editOrderDetails = async ({ rxData, gridRows, userId, taskId, contract, dispQty }) => {
  try {
    console.log('Calling EditOrderDetails API with payloads:', gridRows.length);
    const pharmacyAuth = rxData[0]?.PharmacyAuth || '';
    const vendorAuth = rxData[0]?.VendorAuth || '';
    console.log('PharmacyAuth:', pharmacyAuth, 'VendorAuth:', vendorAuth);

    const results = await Promise.all(
      gridRows.map(async (row) => {
        const payload = {
          pNDC: row.NDC,
          pTaskID: taskId || rxData.TaskDetail.TaskID,
          pPresID: row.PresID,
          pUserID: userId,
          DispQty: row?.['Disp Qty'] || row?.DispQty ,
          CancelQty: row?.['Cancel Qty'] ?? row?.CancelQty ?? 0,
          Memberpay: row.MemberPays || row?.['Member Pays']|| 0,
          Reason: row.Reason || '',
          Status: 0,
          Contract: contract || rxData.TaskDetail.Contract,
          VendorPharmacyAuth: rxData.PharmacyAuth || '',
          VendorAuth:  row.VendorAuth|| ''
        };
        console.log('Posting to /order/EditOrderDetails:', payload);

        return apiClient.post('/order/EditOrderDetails', payload);
      })
    );

    return results;
  } catch (err) {
    console.error('Prescription submission failed', err);
    throw err;
  }
};

export const savePrescription = async (payload) => {
  try {
    console.log(`Loop: ${payload.Loop} Payload:`, payload);
    const response =  await apiClient.post('/order/SaveProcessPrescription', payload);
    console.log("SavePrescription API response:", response || response?.data);
    return response;
  } catch (err) {
    console.error("Save prescription failed:", err);
    throw err;
  }
};

export const cancelEntireOrder = async (taskId, contract, cancelReason, userId)=>{
  try {
    const payload = {
      TaskID: taskId,
      Contract: contract,
      CancelReason: cancelReason,
      UserID: userId
    };

    console.log("Canceling entire order with payload:", payload);

    const response = await apiClient.post('/cancelorder/CancelEntireOrder', payload);

    if (response.status === 200 /*&& response?.Message === "Order cancelled successfully" */) {
    
    console.log("CancelEntireOrder API response:");
    }

    return response.data;
  } catch (error) {
    console.error("Error during cancelEntireOrder:", error);
    throw error;
  }
}

// validate order details



export const validateOrder = async ({ contract, pharmacyId, taskId }) => {
  try {
    console.log("Validating Order with payload:", {
      Contract: contract, 
      PharmacyID: pharmacyId,
      TaskID: taskId
    });
    const response = await apiClient.post('/order/ValidateOrder', {
      Contract: contract,
      PharmacyID: pharmacyId,
      TaskID: taskId
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });
    console.log("Validating Order with payload:", {
      Contract: contract, 
      PharmacyID: pharmacyId,
      TaskID: taskId
    });

    console.log("Validate Order Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Validate Order Failed:", error);
    throw error;
  }
};


//api for fetcing get accumulator details

export const getPremierAccumulatorModels = async (contract) => {
  try {
    const response = await apiClient.get(`/accumlator/GetPremierAccumlatorModel?Contract=${contract}`);
    console.log("Get Premier Accumulator Models Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching Premier Accumulator Models:", error);
    throw error;
  }
}

// api for fetching costshare pharmacy

export const loadRxCostPharmacy = async (contract, pharmCode, rxItemsXml) => {
  try {
    const payload = {
      Contract: contract,
      PharmCode: pharmCode,
      RxItems: rxItemsXml
    };
    console.log("Fetching Rx Cost Pharmacy with payload:=====>", payload);
    const response = await apiClient.post('/order/LoadRxCostPharmacy', payload);
    console.log("Rx Cost Pharmacy Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching Rx Cost Pharmacy:", error);
    throw error;
  }
};

// api for fetching the rebate flag

export const loadRebateValidationFlag = async (contract, memberId, pharmacyId, userName) => {
  try {
    const payload = {
      Contract: contract,
      MemberId: memberId,
      PharmacyID: pharmacyId,
      UserName: userName
    };

    const response = await apiClient.post('/accumlator/LoadgetRebateValidateFlag', payload);
    console.log("Rebate Validate Flag Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching rebate validation flag:", error);
    throw error;
  }
};

// api for fetching the Cost Share

export const LoadCostshareDetails = async (pharmacyId, Column, Value) => {
  try {
    const payload = {
      pharamcyCode: pharmacyId,
      Column: Column,
      Value: Value
    };
console.log("Loading Costshare Details with payload:", payload);
    const response = await apiClient.post('/Order/LoadCostshareDetails', payload);
    
    console.log("CostshareDetails:", response.data);
    return response.data;
  } catch (error) {
    console.error("CostshareDetails:", error);
    throw error;
  }
};

// api for fetching the Cost Share Info

export const LoadCostshareInfo = async (pharmacyId, MemberID, contract) => {
  try {
    const payload = {
      pharamcyCode: pharmacyId,
      member_id: MemberID,
      contract: contract
    };
console.log("Loading Costshare Info with payload:", payload);
    const response = await apiClient.post('/Order/LoadCostshareInfo', payload);
    
    console.log("CostshareInfo:", response.data);
    return response.data;
  } catch (error) {
    console.error("CostshareInfo:", error);
    throw error;
  }
};

// api for LoadSearchMember

export const LoadSearchMember = async (firstName, lastName, dob) => {
  try {
    const payload = {
      FirstName: firstName,
      LastName: lastName,
      DOB: dob
    };
console.log("LoadSearchMember Search functionality with payload:", payload);
    const response = await apiClient.post('/Member/LoadSearchMember', payload);
    
    console.log("LoadSearchMember Search functionality:", response.data);
    return response.data;
  } catch (error) {
    console.error("LoadSearchMember Search functionality:", error);
    return null;;
  }
};

// api for SaveDocument

export const SaveDocument = async (Contract, MemberID, UserName,Documents) => {
  try {
    const payload = {
      Contract: Contract,
      MemberID: MemberID,
      UserName: UserName,
      Documents: Documents,

    };
console.log("LoadSearchMember Save Document with payload:", payload);
    const response = await apiClient.post('auth/savedocument', payload);
    
    console.log("LoadSearchMember Save Document:", response.data);
    return response.data;
  } catch (error) {
    console.error("LoadSearchMember Save Document:", error);
    return null;;
  }
};


// api for SavePrescriptionDocument

export const SavePrescriptionDocument = async (Contract, MemberID, UserName,Documents ,docTypeDescription , DummyProviderID, DummyGroupID) => {
  try {
    const payload = {
      Contract: Contract,
      MemberID: MemberID,
      UserName: UserName,
      Documents: Documents,
      Speciality :  "Infertility",
      DocTypeDesc: docTypeDescription,
      ProviderID: DummyProviderID,
      GroupID: DummyGroupID
    };
console.log("LoadSearchMember Save Prescription Document with payload:", payload);
    const response = await apiClient.post('/uploaddocuments/saveprescriptiondocument', payload);
    
    console.log("LoadSearchMember Save Prescription Document:", response.data);
    return response.data;
  } catch (error) {
    console.error("LoadSearchMember Save Prescription Document:", error);
    return null;;
  }
};
// api for CreateAuth

export const CreateAuth = async (Contract, MemberID, DummyProviderID, AddressId,GroupId,CptCode,Icd9Code,UserName) => {
  try {
    const payload = {
      Contract: Contract,
      MemId: MemberID,
      SerProId: DummyProviderID,
      AddressId: AddressId,
      GroupId:GroupId,
      CptCode: CptCode,
      Icd9Code: Icd9Code,
      Username: UserName
    };
console.log("LoadSearchMember Create Auth with payload:", payload);
    const response = await apiClient.post('auth/CreateAuthForUploadDocument', payload);
    
    console.log("LoadSearchMember Create Auth:", response.data);
    console.log("Auth has been created successfully");
    return response.data;
  } catch (error) {
    console.error("LoadSearchMember Create Auth:", error);
    return null;;
  }
};
// api for CreateAuth

export const CreateTask = async (Contract, MemberID, userID, AuthNumber) => {
  try {
    const payload = {
      Contract: Contract,
      MemberId: MemberID,
      TaskDesc: "Online Rx Request",
      TaskTo:  "CSA-Online-Queue",
      CreatedUser: userID,
      AuthNo: AuthNumber,
      Notes: "Request for Rx Authorization.\nPharmacy user uploaded the doc"
    };
console.log("LoadSearchMember Create Task with payload:", payload);
    const response = await apiClient.post('/auth/createtask', payload);
    
    console.log("LoadSearchMember Create Task:", response.data);
    return response.data;
  } catch (error) {
    console.error("LoadSearchMember Create Task:", error);
    return null;;
  }
};

// api for SaveUploadedDocForAuth

export const SaveUploadedDocForAuth = async ( FaxIDs, MemberID, AuthNumber, Contract) => {
  try {
    const payload = {
      Contract: Contract,
      MemberID: MemberID,
      FaxIDs: FaxIDs,
      AuthNo: AuthNumber
        };
console.log("LoadSearchMember Save Uploaded Doc For Auth with payload:", payload);
    const response = await apiClient.post('auth/SaveUploadedDocForAuth', payload);
    
    console.log("LoadSearchMember Save Uploaded Doc For Auth:", response.data);
    return response.data;
  } catch (error) {
    console.error("LoadSearchMember Save Uploaded Doc For Auth:", error);
    return null;;
  }
};
// api for LoadSearchMember

export const GetPathForMember = async (PatientID, Contract, ContractCode, docTypeDescription) => {
  try {
    const payload = {
      Contractcode: ContractCode,
      Contract: Contract,
      MemberID: PatientID,
      DocTypeDesc: docTypeDescription
    };
console.log("LoadSearchMember with payload:", payload);
    const response = await apiClient.post('/uploaddocuments/getpathformember', payload);
    
    
    console.log("GetPathForMember:", response.data);
    return response.data;
  } catch (error) {
    console.error("GetPathForMember:", error);
    return null;
  }
};

export const UploadDocument = async (fileId, filePath, fileName, noOfPages, 
  docTypeDesc, inputbytes, filesize, memberid, Contract, contractcode, DocTypeDescription
) => {
  try {
    const payload = {
      FileID: fileId,
      FilePath: filePath,
      FileName: fileName,
      NoOFPages: noOfPages,
      DocTypeDesc: docTypeDesc,
      inputBytes: inputbytes,
      fileSize: filesize,
      memberId: memberid,
      contract: Contract,
      contractCode: contractcode,
      docTypeDescription: DocTypeDescription
    };
console.log("UploadDocument with payload:", payload);
    const response = await apiClient.post('/uploaddocuments/Upload', payload);

    console.log("UploadDocument:", response.data);
    return response.data;
    } catch (error) {
    console.error("UploadDocument:", error);
    return null;
  }
}

// [
//   {
//     "FileID": "string",
//     "FilePath": "string",
//     "FileName": "string",
//     "NoOFPages": 0,
//     "DocTypeDesc": "string",
//     "inputBytes": "string",
//     "fileSize": 0,
//     "memberId": "string",
//     "contract": "string",
//     "contractCode": "string",
//     "docTypeDescription": "string"
//   }
// ]

// api LoadEmpContracts

export const LoadEmpContracts = async (Contract) => {
  try {
    const payload = { Contract };
    console.log("LoadEmpContracts with payload:", payload);
    const response = await apiClient.get('/employer/LoadEmpContracts', { params: payload });
    console.log("LoadEmpContracts:", response.data);
    return response.data;
  } catch (error) {
    console.error("LoadEmpContracts:", error);
    return null;
  }
};

// api to save finalized claim

export const SaveFinalizedClaim = async (ClaimID,contract, MemberID,AuthorizationNumber,
  CostShareAtOrderDispense, TotalCostShareAfterClaimsAdjudication,OrderAmount,userId  ) => {
  try {
    const payload = {
      ClaimID: ClaimID,
      MemberID: MemberID,
      Contract: contract,
      AuthNo: AuthorizationNumber,
      CostShareAtOrderDisp: CostShareAtOrderDispense, 
      TotCostSharefromHP: TotalCostShareAfterClaimsAdjudication,
      TotalOrderAmount: OrderAmount,
      UserID: userId
    };
console.log("SaveFinalizedClaim payload:", payload);
    const response = await apiClient.post('/Order/SaveFinalizedClaim', payload);
    
    console.log("CostshareInfo:", response.data);
    return response.data;
  } catch (error) {
    console.error("CostshareInfo:", error);
    throw error;
  }
};

// dispensed order api for submitted claims

export const loadDispensedData = async ( flag, pharmacyId, column = "", value = "", fromDate = "", toDate = "", userId) => {
  try {
    const payload = {
      Flag: flag,
      PharmacyID: pharmacyId,
      Column: column,
      Value: value,
      FromDate: fromDate,
      ToDate: toDate,
      UserId: userId
    };
    console.log("Loading dispensed data with payload:", payload);
    const response =  await apiClient.post('/dispensedorder/LoadDispensedData', payload);
    console.log("Load Dispensed Data Response:", response.data);
    if (
      response.status === 200 &&
      (Array.isArray(response.data?.Submitted_TaskDetails) || Array.isArray(response.data?.Paid_TaskDetails))
    ) {
      const hasSubmitted = Array.isArray(response.data?.Submitted_TaskDetails) && response.data.Submitted_TaskDetails.length > 0;

const resultData = hasSubmitted
  ? response.data.Submitted_TaskDetails
  : response.data.Paid_TaskDetails;

const FilteredData = hasSubmitted
  ? response.data?.Results?.Filtered_SubmitTask ?? []
  : response.data?.Results?.Filtered_PaidTask ?? [];


      return {
        success: true,
        data: resultData,
        filterData: FilteredData
      };
}else {
      return {
        success: false,
        message: response.data?.Message || "No records found."
      };
    }
  }
  catch (err) {
    console.error('Error during loadOrder:', err);
    return {
      success: false,
      message: 'An error occurred while loading data. Please try again later.',
    };
  }
} 


export const loadRXCostshareDetails = async (
  contract,
  memberId,
  userName,
  authNo,
  cost,
  taskNo,
  lockcostshareFlag,
  drugCount,
 
) => {
  try {
    const payload = {
      Contract: contract,
      MemberID: memberId,
      UserName: userName,
      Authno: authNo,
      Cost: cost,
      TaskNo: taskNo,
      LockcostshareFlag: lockcostshareFlag,
      DrugCount: drugCount
    };

   
    console.log("Loading RX costshare details with payload:", payload);

    const response = await apiClient.post('/order/LoadRXcostshareDetails', payload);

    console.log("Load RX Costshare Details Response:", response.data);

    if (response.status === 200 && response.data) {
      return {
        success: true,
        data: response.data
      };
    } else {
      return {
        success: false,
        message: response.data?.Message || "Unexpected response from server."
      };
    }
  } catch (err) {
    console.error("Error during LoadRXcostshareDetails:", err);
    return {
      success: false,
      message: "An error occurred while loading costshare details. Please try again later."
    };
  }
};

export const saveRXCostshareDetails = async (
  taskNo,
  contract,
  memberId,
  userName,
  authNo,
  cost,
  RxcostwithoutrebateFlag, 
  rx_cost_before_costshare,
  drugCount,
  
  
 
) => {
  try {
    const payload = {
      TaskNo: taskNo,
      Contract: contract,
      MemberID: memberId,
      UserName: userName,
      Authno: authNo,
      Cost: cost,//pharmacyremb
      calc_cost_share_without_rebate_flag: RxcostwithoutrebateFlag, 
      Cost_without_rebate: rx_cost_before_costshare, //rx cost before cost share
      DrugCount: drugCount,
      
    };

   
    console.log("Loading RX costshare details with payload:", payload);

    const response = await apiClient.post('/order/SaveRXCostShareDetails', payload);

    console.log("Load RX Costshare Details Response:", response.data);

    if (response.status === 200 && response.data) {
      return {
        success: true,
        data: response.data
      };
    } else {
      return {
        success: false,
        message: response.data?.Message || "Unexpected response from server."
      };
    }
  } catch (err) {
    console.error("Error during LoadRXcostshareDetails:", err);
    return {
      success: false,
      message: "An error occurred while loading costshare details. Please try again later."
    };
  }
};


export const loadRXCostshareValidate = async ( memberId, authNo, contract ) => {
  try {
    const payload = {
      MemberId: memberId,
      AuthNo: authNo,
      Contract: contract
    };
    console.log("Calling LoadgetRXCostshareValidate with payload:", payload);
    const response = await apiClient.post('/accumlator/LoadgetRXCostshareValidate', payload);
    console.log("LoadgetRXCostshareValidate response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error in LoadgetRXCostshareValidate:", error);
    throw error;
  }
};


export const saveCostShareRebateData = async (
  pharmReimbCostWithRebate,
  pharmReimbCostWithoutRebate,
  costShareCalcWithoutRebateFlag,
  costShareAmount,
  authorizationNumber,
  taskId,
  contract,
  username,
  memberId,
  menopurCostShare
) => {
  try {
    const payload = {
      PharmReimbCostWithRebate: pharmReimbCostWithRebate,//pharm
      PharmReimbCostWithoutRebate: pharmReimbCostWithoutRebate,//rx cost 
      CostShareCalcWithoutRebateFlag: costShareCalcWithoutRebateFlag,
      CostShareAmount: costShareAmount,//mebmber 
      AuthorizationNumber: authorizationNumber,
      TaskId: taskId,
      Contract: contract,
      Username: username,
      MemberId: memberId,
      MenopurCostshare: menopurCostShare,
    };
    console.log("Saving CostShare Rebate Data with payload:", payload);
    const response = await apiClient.post('/order/SaveCostShareRebateData', payload);
    console.log("SaveCostShareRebateData response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error in SaveCostShareRebateData:", error);
    throw error;
  }
};



export const fetchAvailityMemberCoverage = async (
  memberid,
  patientFirstname,
  patientLastname,
  patientBirthdate,
  Contract,
  sourcesystem,
  User
) => {
  try {
    const payload = {
      memberId: memberid,
      patientFirstName: patientFirstname,
      patientLastName: patientLastname,
      patientBirthDate: patientBirthdate,
      contract: Contract,
      sourceSystem: sourcesystem,
      user: User
    };

    console.log("Fetching Availity Member Coverage with payload:", payload);
    const response = await axios.post('https://trackerapp.winfertility.com/api/MemberCoverages/AvailityMemberCoverages', payload);
    console.log("Availity Member Coverage Response this iis from => :", response);
    return response.data;
  } catch (error) {
    console.error('Error fetching Availity Member Coverage:', error);
    throw error;
  }
};

export const availityOonUmrValidation = async ( contract, memberID, user ) => {
  try {
    const payload = {
      Contract: contract,
      MemberID: memberID,
      User: user
    };
    console.log("Calling Availity_OON_UMR_Validation with payload:", payload);
    const response = await apiClient.post('/order/Availity_OON_UMR_Validation', payload);
    console.log("Availity_OON_UMR_Validation response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error in Availity_OON_UMR_Validation:", error);
    throw error;
  }
};


//saveUpdateClaims api for updating claims

export const saveUpdateClaimData = async (
  cLM_CLAIM_ID,
  cLM_TASK_ID,
  cLM_MEMBER_ID,
  cLM_GROUP_ID,
  cLM_CONTRACT_DESC,
  cLM_CONTRACT_ID,
  aVL_GROUP_ID,
  aVL_PATIENT_SUB_FLAG,
  aVL_SUBSCRIBER_FIRST_NAME,
  aVL_SUBSCRIBER_ID,
  aVL_SUBSCRIBER_LAST_NAME,
  aVL_SUBSCRIBER_REL_FLAG,
  aVL_DEDUCTIBLE_Total,
  aVL_DEDUCTIBLE,
  aVL_CO_INS,
  aVL_COPAY,
  aVL_OOP_Total,
  aVL_OOP_REM,
  aVL_MEMB_GENDER,
  aVL_SUB_GENDER,
  bILLED_AMOUNT,
  lAST_USER,
  eRROR
) => {
  try {
    const payload = {
      CLM_CLAIM_ID: cLM_CLAIM_ID,
      CLM_TASK_ID: cLM_TASK_ID,
      CLM_MEMBER_ID: cLM_MEMBER_ID,
      CLM_GROUP_ID: cLM_GROUP_ID,
      CLM_CONTRACT_DESC: cLM_CONTRACT_DESC,
      CLM_CONTRACT_ID: cLM_CONTRACT_ID,
      AVL_GROUP_ID: aVL_GROUP_ID,
      AVL_PATIENT_SUB_FLAG: aVL_PATIENT_SUB_FLAG,
      AVL_SUBSCRIBER_FIRST_NAME: aVL_SUBSCRIBER_FIRST_NAME,
      AVL_SUBSCRIBER_ID: aVL_SUBSCRIBER_ID,
      AVL_SUBSCRIBER_LAST_NAME: aVL_SUBSCRIBER_LAST_NAME,
      AVL_SUBSCRIBER_REL_FLAG: aVL_SUBSCRIBER_REL_FLAG,
      AVL_DEDUCTIBLE_Total: Number(aVL_DEDUCTIBLE_Total) || 0,
      AVL_DEDUCTIBLE: Number(aVL_DEDUCTIBLE) || 0,
      AVL_CO_INS: Number(aVL_CO_INS) || 0,
      AVL_COPAY: Number(aVL_COPAY) || 0,
      AVL_OOP_Total: Number(aVL_OOP_Total) || 0,
      AVL_OOP_REM: Number(aVL_OOP_REM) || 0,
      AVL_MEMB_GENDER: aVL_MEMB_GENDER,
      AVL_SUB_GENDER: aVL_SUB_GENDER,
      BILLED_AMOUNT: Number(bILLED_AMOUNT) || 0,
      LAST_USER: lAST_USER,
      ERROR: eRROR
    };

    console.log("Calling SaveUpdateClaimsData with payload:", payload);

    const response = await apiClient.post('/order/SaveUpdateClaimsData', payload);

    console.log("SaveUpdateClaimsData response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error in SaveUpdateClaimsData:", error);
    throw error;
  }
};

//cancel order apis

//cancel load grid api

 export const loadCancelledRX = async (pharmacyId, flag, contract, column, value, userId) => {
  try{

    const payload = {
      PharmacyID: pharmacyId,
      Flag: flag,
      Contract: contract,
      Column: column,
      Value: value,
      UserId: userId
    };
    console.log("Loading cancelled RX with payload:", payload);
    const response = await apiClient.post('cancelorder/LoadCancelledRX', payload);
    console.log("Load Cancelled RX Response:", response.data);
    if (response.status === 200 && Array.isArray(response.data?.TaskDetails)) {
      const taskDetails = response.data.TaskDetails;
      const filterData = response.data?.ComboTaskDetails || [];
      return {
        success: true,
        data: taskDetails,
        filter: filterData
      };
    } else {
      return {
        success: false,
        message: response.data?.Message || "No records found."
      };
    }

  }catch (err){
    console.error('Error during loadCancelledRX:', err);
    return {
      success: false,
      message: 'An error occurred while loading data. Please try again later.',
    };
  }
 }

 export const loadCancelledRXDetails = async ( pharmacyId, memberId,formattedAuthNo,taskId,contract) => {
    try{
      const payload = {
        PharmacyID: pharmacyId,
        MemberID: memberId,
        FormattedAuthNo: formattedAuthNo,
        TaskID: taskId,
        Contract: contract
      };
      console.log("Loading cancelled RX details with payload:", payload);
      const response = await apiClient.post('cancelorder/LoadCancelledRXDetails', payload);
      console.log("Load Cancelled RX Details Response:", response.data);
      if (response.status === 200 && Array.isArray(response.data?.CancelledRxTaskDetails)) {
        const taskDetails = response.data.CancelledRxTaskDetails;
        return {
          success: true,
          data: taskDetails
        };
      }
 else {
        return {
          success: false,
          message: response.data?.Message || "No records found."
        };
      }
    }
    catch (err){
      console.error('Error during loadCancelledRXDetails:', err);
      return {
        success: false,
        message: 'An error occurred while loading data. Please try again later.',
      };
    }
 }

export const loadFormularyAndPricing = async (contract, flag, pharmacyId, drgName, column, value) => {
  try {
    const payload = {
  Contract: contract,
  Flag: flag,
  PharmacyID: pharmacyId,
  DrgName: drgName,
  Column: column,
  Value: value
}

  console.log('Lodaing formulary and pricing with payload', payload);
  const response = await apiClient.post('formulary/LoadFormularyAndPricing', payload);
  console.log('LoadFormularyAndPricing response:', response.data);
  if (response.status === 200 && Array.isArray(response.data?.FP_TaskDetails)) {
    const formularyData = response.data.FP_TaskDetails;
    return {
      success: true,
      data: formularyData
    };
  } else {
    return {
      success: false,
      message: response.data?.Message || "No records found."
    };

  }} catch (err){
    console.error('Error during loadFormularyAndPricing:', err);
    return {
      success: false,
      message: 'An error occurred while loading formulary and pricing data. Please try again later.',
    };
  }
} 

export const viewPriceDetails = async ( flag, pharmacyId, drgName, column, value) => {
  try {
    const payload = {

  Flag: flag,
  PharmacyID: pharmacyId,
  DrgName: drgName,
  Column: column,
  Value: value
}

  console.log('Lodaing formulary and pricing with payload', payload);
  const response = await apiClient.post('formulary/ViewPriceDetails', payload);
  console.log('LoadFormularyAndPricing details response:', response.data);
  if (response.status === 200 && Array.isArray(response.data?.FP_TaskDetails)) {
    const formularyData = response.data.FP_TaskDetails;
    return {
      success: true,
      data: formularyData
    };
  } else {
    return {
      success: false,
      message: response.data?.Message || "No records found."
    };

  }} catch (err){
    console.error('Error during loadFormularyAndPricing:', err);
    return {
      success: false,
      message: 'An error occurred while loading formulary and pricing data. Please try again later.',
    };
  }
} 

export const loadPaidClaimsDetails = async (checkNo, pharmacyId, contract, column, value) => {
  const payload = {
    CheckNo: checkNo,
    PharmacyID: pharmacyId,
    Contract: contract,
    Column: column,
    Value: value
  }
  console.log('Loading Paid Claims Details with payload:', payload);
  try {
    const response = await apiClient.post('dispensedorder/LoadPaidClaimsDetails', payload);
    console.log('LoadPaidClaimsDetails response:', response.data);
    if (response.status === 200 && Array.isArray(response.data?.TaskDetails)) {
      const taskDetails = response.data.TaskDetails;
      const filterData = response.data?.RxTaskDetails|| [];
      return {
        success: true,
        data: taskDetails,
        filterData: filterData
      };
    } else {
      return {
        success: false,
        message: response.data?.Message || "No records found."
      };
    }
  }catch (err) {
    console.error('Error during loadPaidClaimsDetails:', err);
    return {
      success: false,
      message: 'An error occurred while loading paid claims details. Please try again later.',
    };
  }
}

export const loadDispensedDataCigna = async (pharmacyId, column, value, flag) => {
  const payload = {
    PharmacyID: pharmacyId,
    Column: column,
    Value: value,
    Flag: flag
  }
  console.log('loading dispensed data with payload:', payload);
  try {
    const reaponse = await apiClient.post('dispensedorder/LoadDispensedDataCigna', payload);
    console.log('LoadDispensedDataCigna response:', reaponse.data);
    if (reaponse.status === 200 && Array.isArray(reaponse.data?.TaskDetails)) {
      const taskDetails = reaponse.data.TaskDetails;
      return {
        success: true,
        data: taskDetails,
        filterData: reaponse.data?.Result?.Filtered_CignaTask || []
      };
    } else {
      return {
        success: false,
        message: reaponse.data?.Message || "No records found."
      };
    }
  }catch (err) {
    console.error('Error during loadDispensedDataCigna:', err);
    return {
      success: false,
      message: 'An error occurred while loading dispensed data. Please try again later.',
    };
  }

}

export const sendEmail = async (userId, comments, department, senderEmail) => {
  const payload = {
    UserID: userId,
    Comments: comments,
    Department: department, 
    SenderEmail: senderEmail
}
console.log('Sending email with payload:', payload);
  try {
    const response = await apiClient.post('email/sendemail', payload);
    console.log('SendEmail response:', response.data);
    if(response){
      console.log('Email sent successfully');
      return {
        success: true,
        message: 'Email sent successfully.'
      };
      
    }
  }catch (err) {
    console.error('Error during sendEmail:', err);
    return {
      success: false,
      message: 'An error occurred while sending email. Please try again later.',
    };
  }
}

export const validateForgotPassword = async (userId, password, pharmacyId, Mode) => {
  const payload = {
    UserID: userId,
    Password: password,
    PharmacyID: pharmacyId,
    Mode: Mode
  };
  console.log('Validating forgot password with payload:', payload);
  try {
    const response = await apiClient.post('login/ValidateForgotPassword', payload);
    console.log('ValidateForgotPassword response:', response.data);
    
    if (response) {
      return {
        success: true,
        message: 'Password validation successful.',
        data: response.data
      };
    } else {
      return {
        success: false,
        message: response.data?.message || "Validation failed. Please check your credentials."
      };
    }
  }catch (error) {
    console.error('Error during validateForgotPassword:', error);
    return {
      success: false,
      message: 'An error occurred while validating forgot password. Please try again later.',
    };
  }
}

export const validateChangePassword = async (userId, oldPassword, newPassword, pharmacyId) => {
  const payload = {
    UserID: userId,
    OldPassword: oldPassword,
    NewPassword: newPassword,
    PharmacyID: pharmacyId,
   
  };
  console.log('Validating forgot password with payload:', payload);
  try {
    const response = await apiClient.post('login/ValidateChangePassword', payload);
    console.log('ValidateChangePassword response:', response.data);
    const data = response.data;
    console.log('Data from ValidateChangePassword:', data.Count);
    
    if (data.Count === 1) {
      return {
        success: true,
        message: 'Password Changed successful.'
      };
    } else {
      return {
        success: false,
        message: response.data?.message || "Changing Password failed. Please check your credentials."
      };
    }
  }catch (error) {
    console.error('Error during validateChangePassword:', error);
    return {
      success: false,
      message: 'An error occurred while validating forgot password. Please try again later.',
    };
  }
}

export const loadAccumulator = async (memberId, authNo, contract) => {
  try {
    const payload = {
      MemberId : memberId,
      AuthNo: authNo,
      Contract: contract
    }
    console.log('Loading accumulator data with payload:', payload);
    const response = await apiClient.post('/accumlator/LoadAccumlator', payload);
    console.log('LoadAccumulator response:', response.data);

    if (response) {
      const accumulatorDetails = response.data;
      return {
        success: true,
        data: accumulatorDetails
      };
    } else {
      return {
        success: false,
        message: response.data?.Message || "No records found."
      };
    }
  }catch (error) {
    console.error('Error during loadAccumulator:', error);
    return {
      success: false,
      message: 'An error occurred while loading accumulator data. Please try again later.',
    };
  }
}

// api for loading cignasso

export const validateLoginSSO =  async (networkId) => {
  try {
    const payload = {
      NetworkId: networkId
    };
    console.log('Validating SSO login with payload:', payload);
    const response = await apiClient.post('/login/ValidateLoginSSO', payload);
    if (response.status === 200 && response.data) {
      console.log('ValidateLoginSSO response:', response.data);
       return {
        success: true,
        data: response.data
      };

    } else {
      return {
        success: false,
        message: response.data?.Message || "SSO login validation failed."
        
      };
    }
  } catch (error) {
    console.error('Error during validateLoginSSO:', error);
    return {
      success: false,
      message: 'An error occurred while validating SSO login.'
    };
  }
}

// get Attachment Path api

export const getAttachmentPath = async (attachmentPath) => {
  try {
    const payload = { AttachmentPath: attachmentPath };
    const response = await apiClient.post('/order/GetAttachmentPath', payload);
    console.log('GetAttachmentPath response:', response.data);
    // The API returns the URL as a string
    return response.data; // This is the direct URL string
  } catch (error) {
    console.error('Error during getAttachmentPath:', error);
    return '';
  }
}

// fedex api for tracking
export const trackFedexShipment = async (trackingNumber) => {
  try {
    const payload = { TrackingNumber: trackingNumber };
    console.log('Tracking FedEx shipment with payload:', payload);
    const response = await apiClient.post('/fedex/track', payload);
    console.log('TrackFedexShipment response:', response.data);
    
    if (response.status === 200 && response.data) {
      console.log('FedEx tracking data:', response.data);
      return {
        success: true,
        data: response.data
      };
    } else {
      return {
        success: false,
        message: response.data?.Message ,
      
      };
    }
  } catch (error) {
    console.error('Error during trackFedexShipment:', error);
    return {
      success: false,
      message: 'An error occurred while tracking the shipment. Please try again later.'
    };
  }
}

// this is for menopaur api

export const loadMemberConcern = async (taskId, contract) => { 
  try {
    const payload = {
      TaskID: taskId,
      Contract: contract
    }
    console.log('Loading member concern with payload:', payload);
    const response = await apiClient.post('/order/LoadMemberConcern', payload);
    console.log('LoadMemberConcern response:', response.data);
    if (response.status === 200 && response.data) {
      return {
        success: true,
        data: response.data
      };
    } else {
      return {
        success: false,
        message: response.data?.Message || "No records found."
      };
    }

  } catch (error) {
    console.error('Error during loadMemberConcern:', error);
    return {
      success: false,
      message: 'An error occurred while loading member concern. Please try again later.'
    };
  }
}


export const uploadDocumentMainPathCreator = async (documentItems) => {
  try {
    // documentItems should be an array of objects as per your prompt
    // Each object should have FileID, FilePath, FileName, NoOFPages, DocTypeDesc, inputBytes, fileSize, memberId, contract, contractCode, docTypeDescription

    const payload = documentItems; // Send as array

    console.log("Uploading document main path with payload:", payload);

    const response = await apiClient.post('/uploaddocuments/Upload', payload);

    console.log("uploadDocumentMainPathCreator response:", response.data);

    return response.data;
  } catch (error) {
    console.error("Error during uploadDocumentMainPathCreator:", error);
    return null;
  }
};



const SERVICE_URL = "https://trackerapp.winfertility.com/api/";

export async function getWinCardUrl(info) {
  try {
    const param = `_Params=${encodeURIComponent(JSON.stringify(info))}`;
    const response = await axios.post(
      SERVICE_URL + "ReviewRX/GetWINCardURL",
      param,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
    );
    // The API should return the URL as a string
    
    return response.data;
  } catch (error) {
    console.error("Error fetching WIN Card URL:", error);
    return null;
  }
}

export const getYear = async (pharmacyId, userId) => {
  try {
    const payload = {
      "PharmId": pharmacyId,
      "UserId": userId,
}
    console.log("getYear with payload:", payload);
    const response = await apiClient.post('/dispensedorder/GetYears', payload);
    if (response.status === 200 && response.data) {
      console.log("getYear response:", response.data);
      return response.data;
    }
    } catch (error) {
    console.error("Error in getYear:", error);
    return null;
  }
}

export const getYearMonth = async (pharmacyId, userId, year) => {
  try {
    const payload = {
      "PharmId": pharmacyId,
      "Year": year,
  "UserId": userId
    }
    console.log("getYearMonth with payload:", payload);
    const response = await apiClient.post('/dispensedorder/GetMonths', payload);
    if (response.status === 200 && response.data) {
      console.log("getYearMonth response:", response.data);
      return response.data;
    }
  }catch (error) {
    console.error("Error in getYearMonth:", error);
    return null;
  }
}

export const getRemittanceReports = async (pharmacyId, userId, month, year) => {
  try {

    const payload = {
      "PharmId": pharmacyId,
      "UserId": userId,
      "Month": month,
      "Year": year
    }
    console.log("getRemittanceReports with payload:", payload);
    const response = await apiClient.post('/dispensedorder/GetRemittanceReports', payload);
    if (response.status === 200 && response.data) {
      console.log("getRemittanceReports response:", response);
      return response.data;
    }

  } catch (error) { 
    console.error("Error in getRemittanceReports:", error);
    return null;
  }
}

export const getRemittanceReportsPDF = async (pharmacyId, userId, chequeNumber, referenceNumber, eftNumber, contract) => {
  try {

    const payload = {
      "PharmId": pharmacyId,
      "UserId": userId,
      "ChequeNumber": chequeNumber,
      "Referencenumber": referenceNumber,
      "EFTnumber": eftNumber,
      "Contract": contract
    }
    console.log("getRemittanceReportsPDF with payload:", payload);
    const response = await apiClient.post('/dispensedorder/GetRemittanceReportPdf', payload);
    if (response.status === 200 && response.data) {
      console.log("getRemittanceReportsPDF response:", response.data);
      return response.data;
    }

  } catch (error) {
    console.error("Error in getRemittanceReportsPDF:", error);
    return null;
  }
}

export const getOpenOrdersFile = async (memberId, file_url, contract, docType,  bytes ) => {
  try {
    const payload = {
      MemberID: memberId,
      PDF_Document: file_url,
      Contract: contract,
      DocType: docType,
      PDF_Bytes: bytes
    }
    console.log("getOpenOrdersFile with payload:", payload);
    const response = await apiClient.post('/order/ViewAttachment', payload);
    
    if (response.status === 200 && response.data) {
      console.log("getOpenOrdersFile response:", response.data);
      return response.data;
    }
  } catch (error) {
    console.error("Error in getOpenOrdersFile:", error);
    return null;
  }
}

export const loadLockedItems = async (pharmacyId, taskID) => {
  try {
    const payload = {
      PharmacyID: pharmacyId,
      TaskID: taskID
    }
    console.log("loadLockedItems with payload:", payload);
    const response = await apiClient.post('/UserAccess/LoadLockedItems', payload);
    console.log("loadLockedItems response:", response.data.TaskDetail);
    return response.data.TaskDetail;
} catch (error) {
    console.error("Error in loadLockedItems:", error);
    return null;
  }
}

export const getUsers = async (pharmacyId, userId) => {
  try {
    const payload = {
      PharmacyID: pharmacyId,
      UserID: userId
    }
    console.log("getUsers with payload:", payload);
    const response = await apiClient.post('/UserAccess/getusers', payload);
    console.log("getUsers response:", response.data);
    return response.data;
} catch (error) {
    console.error("Error in getUsers:", error);
    return null;
  }
}

export const selectUsers = async (pharmacyId, userId) => {
  try {
    const payload = {
      PharmacyID: pharmacyId,
      UserID: userId
    }
    console.log("selectUsers with payload:", payload);
    const response = await apiClient.post('/UserAccess/selectuserdetails', payload);
    console.log("selectUsers response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error in selectUsers:", error);
    return null;
  }
}

export const saveUserDetails = async ( userId, firstName, lastName, networkID, email, adminStatus, pharmacyID  ) => {
  try {

    const payload = {
      UserID: userId, 
      FirstName: firstName,
      LastName: lastName,
      NetworkID: networkID,
      Email: email,
      AdminStatus: adminStatus,
      PharmacyID: pharmacyID,
    }
    console.log("saveUserDetails with payload:", payload);
    const response = await apiClient.post('/UserAccess/saveuserdetails', payload);
    console.log("saveUserDetails response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error in saveUserDetails:", error);
    return null; 
  }
}

// {
export const editUserDetails = async ( fullName, userId, firstName, lastName, networkID, email, adminStatus, pharmacyID  ) => {
  try {

    const payload = {
      FullName: fullName,
      UserID: userId, 
      FirstName: firstName,
      LastName: lastName,
      NetworkID: networkID,
      EmailID: email,
      AdminStatus: adminStatus,
      PharmacyID: pharmacyID,
    }
    console.log("saveUserDetails with payload:", payload);
    const response = await apiClient.post('/UserAccess/edituser', payload);
    console.log("saveUserDetails response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error in saveUserDetails:", error);
    return null; 
  }
}

export const lockProcess = async ( contract, userId, taskID, pharmacyId, process) => {
  try {
    const payload = {
      Contract: contract,
      UserID: userId,
      TaskID: taskID,
      PharmacyID: pharmacyId,
      Process: process
    }
    console.log("lockProcess with payload:", payload);
    const response = await apiClient.post('/UserAccess/lockprocess', payload);
    console.log("lockProcess response:", response.data);
    return response.data;

  } catch (error) {
    console.error("Error in lockProcess:", error);
    return null; 
  }
}

export const insertContactUsPBMS = async (pharmacyId, senderEmail,  department, comments) => {
  try {
    const payload = {
      PharmacyID: pharmacyId,
  EmailID: senderEmail,
  Department: department,
  Comments: comments
    }
    console.log("insertContactUsPBMSb with payload:", payload);
    const response = await apiClient.post('/email/insertcontactuspbms', payload);
    console.log("insertContactUsPBMSb response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error in insertContactUsPBMSb:", error);
    return null; 
  }
}

export const saveMemberRefund = async (formData) => {
  try {
    const payload = {
      MemberId: formData.memberID,
      Contract: formData.contract,
      PharmacyId: formData.pharmacyId,
      RefundDate: formData.date,
      RefundAmount: formData.amount,
      PharmacyName: formData.pharmName,
      ClaimID: formData.claimId,
      OrderAmount: formData.orderAmount
    }
    console.log("saveMemberRefund with payload:", payload);
    const response = await apiClient.post('/order/SaveMemberRefund', payload);
    console.log("saveMemberRefund response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error in saveMemberRefund:", error);
    return null;
  }
}

// {
//   "MemberId": "string",
//   "Contract": "string",
//   "PharmacyId": "string",
//   "RefundDate": "string",
//   "RefundAmount": "string",
//   "PharmacyName": "string",
//   "ClaimID": "string",
//   "OrderAmount": "string"
// }


// {
//   "GroupID": "string",
//   "UserID": "string",
//   "ChequeNumber": "string",
//   "Referencenumber": "string",
//   "EFTnumber": "string",
//   "Contract": "string"
// }